import {StatisticModel} from "./statistic-model";

export class StatisticsModel {
  public statistics: StatisticModel[] = [];
}
